import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 1200px;
  height: 80vh;
  padding: 64px 24px 24px;
  background: #2a2a2a;
  border: 1px solid #3f3f3f;
  border-radius: 4px;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
